exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info-label[data-v-4851d444]{display:block;font-size:11px;font-weight:500;color:#757575;text-transform:uppercase;letter-spacing:.4px}.info-value[data-v-4851d444]{margin-top:3px;font-size:15px;font-weight:600;color:#434347}.payment-card__footer-actions[data-v-4851d444]{margin-top:1.25rem;padding-top:1rem;padding-bottom:0;border-top:1px solid rgba(0,0,0,.12)}", ""]);

// exports
